/**
 * https://tc39.es/ecma402/#sec-formatapproximately
 */
export function FormatApproximately(numberFormat, result, _a) {
  var getInternalSlots = _a.getInternalSlots;
  var internalSlots = getInternalSlots(numberFormat);
  var symbols = internalSlots.dataLocaleData.numbers.symbols[internalSlots.numberingSystem];
  var approximatelySign = symbols.approximatelySign;
  result.push({
    type: 'approximatelySign',
    value: approximatelySign
  });
  return result;
}